import { DateTime } from "luxon";
import { useEffect, useState } from "react";

export const useCurrentTime = (refreshRateMs: number): DateTime => {
  const [time, setTime] = useState<DateTime>(DateTime.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(DateTime.now());
    }, refreshRateMs);
    return () => {
      clearInterval(interval);
    };
  }, [refreshRateMs]);
  return time;
};
